import React from 'react';
import { cn } from '../../../utils/classnames';

const LoadingSpinner = ({ size = 20, className = '', color = 'border-tealPrimary' }) => {
  return (
    <svg className="animate-spin h-4 w-4 text-tealPrimary" viewBox="0 0 24 24">
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
    </svg>
  );
};

export default LoadingSpinner;
